export default {
  projectItem: {
    name: null,
    role: null,
    start_year: null,
    start_month: null,
    end_year: null,
    end_month: null,
    notes: null
  },
  projectsList: [],
  projectErrorItem: {
    name: null,
    role: null,
    start_year: null,
    start_month: null,
    end_year: null,
    end_month: null,
    notes: null
  },
  projectsErrorList: []
};
